<script setup lang="ts">
const {
  months,
  month,
  years,
  year,
} = defineProps<{
  months: { value: number; text: string }[]
  years: { value: number; text: string }[]
  month: number
  year: number
}>()

const emit = defineEmits(['updateMonthYear', 'toggleOverlay'])

function updateMonthYear(selectedMonth, selectedYear) {
  emit('updateMonthYear', selectedMonth, selectedYear)
}

function onPrev() {
  let selectedMonth = month
  let selectedYear = year

  const minYear = years[0].value

  if (selectedYear === minYear && selectedMonth === 0)
    return

  if (selectedMonth === 0) {
    selectedMonth = 11
    selectedYear = selectedYear - 1
  }
  else {
    selectedMonth -= 1
  }

  updateMonthYear(selectedMonth, selectedYear)
}

function onNext() {
  let selectedMonth = month
  let selectedYear = year

  const maxYear = years[years.length - 1].value

  if (selectedYear === maxYear && selectedMonth === 11)
    return

  if (selectedMonth === 11) {
    selectedMonth = 0
    selectedYear = selectedYear + 1
  }
  else {
    selectedMonth += 1
  }

  updateMonthYear(selectedMonth, selectedYear)
}

function getMonthYearTitle(): string {
  return `${months[month].text} ${year}`
}
</script>

<template>
  <div class="flex justify-between items-center capitalize font-semibold px-4">
    <AppIcon
      class="
        hover:bg-primary hover:bg-opacity-15
        cursor-pointer
        px-5
        py-4.5
        rounded-xl
        text-primary
      "
      icon="angle-left"
      type="far"
      @click="onPrev"
    />
    <span
      class="
        hover:bg-primary hover:bg-opacity-15
        py-2.5
        px-4
        cursor-pointer
        rounded-xl
        flex
      "
      @click="emit('toggleOverlay')"
    >
      {{ getMonthYearTitle() }}

      <AppIcon class="text-primary ml-2" icon="angle-down" type="far" />
    </span>
    <AppIcon
      class="
        hover:bg-primary hover:bg-opacity-15
        cursor-pointer
        px-5
        py-4.5
        rounded-xl
        text-primary
      "
      icon="angle-right"
      type="far"
      @click="onNext"
    />
  </div>
</template>
